/**
 * Image
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { selectEpi } from 'store/modules/epi';
import ImageBase, { ImageProps } from 'ui-component-library/base/Image';

interface Props extends ImageProps {
	/** Epi property to use when edit the text */
	prop?: string;
}

/** Wrapper for the Image component for handeling Episerver on page editor. */
const Image: React.FC<Props> = ({ prop, ...allProps }) => {
	const epi = useSelector(selectEpi);

	if (epi?.beta?.isEditable && prop) {
		allProps['data-epi-edit'] = prop;
	}

	return React.createElement(ImageBase, allProps);
};

export default Image;
